import styled from 'styled-components'
import { palette } from '../../../theme/palette'

export const HeaderWrapper = styled.div<{ color: string }>`
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  align-items: center;
  background-color: ${props => props.color || palette.mainBlue};
  height: 52px;
  min-height: 52px;
  position: relative;
`

export const LeftHolder = styled.div`
  margin-right: 4px;
  width: 10%;
`

export const RightHolder = styled.div`
  margin-left: 4px;
  width: 10%;
`

export const CloseIframeButton = styled.button.attrs(() => ({
  'tabIndex': 0,
  'data-test': 'back-icon'
}))`
  width: 24px;
  height: 24px;
  border: none;
  background-color: ${palette.transparent};
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  z-index: 2;
  cursor: pointer;
  
  &:focus-visible {
    outline: 2px solid ${palette.white};
  }
`

export const BotInfoHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
`

export const HeaderAvatar = styled.img`
  position: relative;
  top: 8px;
  height: 50px;
  cursor: pointer;
  transition: opacity .3s ease-in-out;
  margin: 0 16px 0 0;
`

export const HeaderTextContainer = styled.div`
  text-align: center;
`

export const HeaderTitle = styled.h1.attrs(() => ({
  id: 'widget-header'
}))`
  font-size: 14px;
  font-weight: 700;
  color: ${palette.white};
  line-height: 16px;
  margin: 0;
`

export const HeaderSubTitle = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  margin: 0;
  color: ${palette.white};
  width: 72vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const CloseIconContainer = styled.div`
  cursor: pointer;
  user-select: none;
  margin-left: 15px;
  animation-duration: 0.3s;
  animation-name: appearIn;
`
